import React, { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { useLocation, useNavigate } from "react-router-dom";
import { Button } from "react-bootstrap";
import WalletModal from "./walletModal"
import { useDispatch, useSelector } from "react-redux";
import {
  useWalletClient,
  useChainId,
  useDisconnect,
} from "wagmi";
import Web3 from "web3";
import $ from 'jquery';
import config from "../config/config";
import { setWallet } from "../reducers/Actions";
import { walletClientToSigner } from "../helper/getprovider";
import { formatNumber, shortText } from "../helper/custommath";

import logo from "../assets/images/logo.png";
import metaIcon from "../assets/images/meta_icon.png";
import walletIcon from "../assets/images/wallet_icon.png";

export default function MainNavbar(props) {
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const chain = useChainId();
  const { disconnect } = useDisconnect();
  const { data: walletClient } = useWalletClient({ chainId: config.network });

  const walletConnection = useSelector((state) => state.walletConnection);

  useEffect(() => {
    handleWalletConnection();
  }, [walletClient]);

  async function handleWalletConnection() {
    console.log(walletClient, walletClient && chain && parseInt(chain) === config.network, "walletClient");
    if (walletClient && chain && parseInt(chain) === config.network) {
      const { transport } = walletClientToSigner(walletClient);
      const web3 = new Web3(transport);
      const userAddr = walletClient.account?.address || "";

      const getBalance = await web3.eth.getBalance(userAddr);
      dispatch(
        setWallet({
          network: parseInt(chain),
          web3,
          address: userAddr,
          provider: transport,
          connect: "yes",
          balance: getBalance,
        })
      );
    } else {
      const fallbackNetwork = parseInt(localStorage.getItem("network")) || config.networkId;
      const web3 = new Web3(config.rpcURl);

      // if ((chain && parseInt(chain) !== config.network) || !chain) {
      //   if (["/dashboard", "/autopooliskd728jsnak382msmakncvae"].includes(location.pathname)) {
      //     navigate("/join-now");
      //   }
      // }

      dispatch(
        setWallet({
          network: fallbackNetwork,
          web3,
          address: "",
          provider: "",
          connect: "no",
        })
      );
    }
  }

  function DisConnect() {
    disconnect();
    localStorage.clear();
    dispatch(
      setWallet({
        network: config?.network,
        web3: "",
        address: "",
        provider: "",
        connect: "no",
      })
    );
    // navigate("/");
  }


  useEffect(() => {
    loadScript();
    return () => {
      $(window).off("scroll load");
    };
  }, []);

  function loadScript() {
    const navbar = $(".navbar-sticky");
    $(window).on("scroll load", function () {
      const scrollTop = $(window).scrollTop();
      if (scrollTop >= 10) {
        navbar.addClass("navbar-sticky--moved-up");
      } else {
        navbar.removeClass("navbar-sticky--moved-up");
      }
    });
  }

  function Redirct() {
    navigate("/dashboard");
  }
  console.log("navvvvvv");
  return (
    <>
      <nav className="navbar navbar-expand-xl main_navbar navbar-sticky">
        <div className="container-fluid">
          <Link className="navbar-brand" to="/">
            <img src={logo} alt="Logo" className="img-fluid logo_img" />
          </Link>
          <button
            className="navbar-toggler"
            type="button"
            data-bs-toggle="offcanvas"
            data-bs-target="#offcanvasNavbar"
            aria-controls="offcanvasNavbar"
            aria-label="Toggle navigation"
          >
            <span className="navbar-toggler-icon"></span>
          </button>

          <div
            className="offcanvas offcanvas-end nav_offcanva"
            tabIndex="-1"
            id="offcanvasNavbar"
            aria-labelledby="offcanvasNavbarLabel"
          >
            <div className="offcanvas-header">
              <h5 className="offcanvas-title" id="offcanvasNavbarLabel">
                <img src={logo} alt="Logo" className="img-fluid logo_img" />
              </h5>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="offcanvas"
                aria-label="Close"
              ></button>
            </div>
            <div className="offcanvas-body">
              <ul className="navbar-nav justify-content-center flex-grow-1 pe-3">
                {["home", "about", "tokensale", "roadmap", "faq"].map(
                  (section) => (
                    <li
                      key={section}
                      className="nav-item"
                      data-bs-dismiss="offcanvas"
                      aria-label="Close"
                    >
                      <Link
                        to={section}
                        spy={true}
                        smooth={true}
                        duration={250}
                        offset={-100}
                        className="nav_link"
                      >
                        {section.charAt(0).toUpperCase() + section.slice(1)}
                      </Link>
                    </li>
                  )
                )}
              </ul>
              {walletConnection && walletConnection.connect == "yes" && walletConnection.address != "" ? <>
                <Button
                  className="primary_btn me-2"
                > {shortText(walletConnection.address)} </Button>
                <Button
                  className="primary_btn"
                  onClick={() => Redirct()} >Dashboard </Button></> :
                <Button
                  className="primary_btn"
                  data-bs-toggle="modal"
                  data-bs-target="#exampleModal"
                >
                  Connect Wallet
                </Button>}
            </div>
          </div>
        </div>
      </nav>
      <WalletModal />
      {/* <div
        className="modal fade model_box"
        id="exampleModal"
        tabIndex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered ">
          <div className="modal-content">
            <div className="modal-header">
              <h1 className="modal-title fs-5" id="exampleModalLabel">
                Connect Wallet
              </h1>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <div className="meta_connect d-flex justify-content-between">
                <div className="text-center">
                  <img
                    src={metaIcon}
                    alt="MetaMask"
                    className="img-fluid"
                    width={50}
                    height={50}
                  />
                  <p className="mb-0">Meta Mask</p>
                </div>
                <div className="text-center">
                  <img
                    src={walletIcon}
                    alt="WalletConnect"
                    className="img-fluid"
                    width={50}
                    height={50}
                  />
                  <p className="mb-0">Connect Wallet</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </>
  );
}
